module.exports = __webpack_public_path__ + "static/media/FILTERS White@3x.424606b7.png";